import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LightInfoComponent } from './light-info.component';



@NgModule({
  declarations: [LightInfoComponent],
  imports: [
    CommonModule
  ],
  exports: [LightInfoComponent]
})
export class LightInfoModule { }
